import { pageRoutes } from "../../../../routes";
import EntitiesListPage from "../../../entityFields/grid/EntitiesListPage";

const FundInvestmentsPage = () => {
  return (
    <EntitiesListPage
      objectType="FundInvestment"
      objectDetailsPathPattern={`/:clientCode/${pageRoutes.portfolio}/${pageRoutes.fundInvestments}/:id`}
      objectsTitle="Fund Investments"
    />
  );
};

export default FundInvestmentsPage;
